import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import RoutineTemplates from "Administrator/commonComponents/RoutineAndMealTemplates/routes/RoutineTemplates";
import MealTemplates from "Administrator/commonComponents/RoutineAndMealTemplates/routes/MealTemplates";

export default store => ({
  path: "routineAndMealTemplates",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-routine-and-meal-templates" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [RoutineTemplates(store), MealTemplates(store)],
});
